module.exports = __webpack_public_path__ + "img/logo_Ymanci.51b79ab0.svg";